module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fChc4EsA.b1b80843.woff2";